import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { AuthProvider } from "@/context/AuthContext";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Product from "@/pages/Product";
import Checkout from "@/pages/Checkout";
import ThankYou, { CartPage } from "@/pages/ThankYou";
import { BlogList, BlogPost, StaticPage } from "@/pages/Content";
import Landing from "@/pages/Landing";
import Account, { CustomerLogin, MagicLogin, ResetPassword } from "@/pages/Account";
import AdminApp from "@/admin/AdminApp";

function App() {
  return (
    <AuthProvider>
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/lp/:slug" element={<Landing />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/categoria/:slug" element={<Catalog />} />
              <Route path="/necessidade/:slug" element={<Catalog />} />
              <Route path="/busca" element={<Catalog />} />
              <Route path="/kits" element={<Catalog />} />
              <Route path="/produto/:slug" element={<Product />} />
              <Route path="/carrinho" element={<CartPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/pedido/:id/obrigado" element={<ThankYou />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/paginas/:slug" element={<StaticPage />} />
              <Route path="/entrar" element={<CustomerLogin />} />
              <Route path="/entrar/magico" element={<MagicLogin />} />
              <Route path="/redefinir-senha" element={<ResetPassword />} />
              <Route path="/conta/*" element={<Account />} />
              <Route path="*" element={<div className="container-na py-20"><h1 className="text-4xl">Página não encontrada</h1></div>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </StoreProvider>
    </AuthProvider>
  );
}

export default App;
